import { useEffect, useState } from 'react'
import View from './view.js'
import query from './query-get-person-by-id.graphql.js'
import { useClient } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

export default function Logic(props) {
  let client = useClient()
  let [, notify] = useNotifications()
  let [person, setPerson] = useState()

  useEffect(() => {
    if (props.recipientId) {
      client
        .query(query, { _id: props.recipientId })
        .toPromise()
        .then(
          ({
            data: {
              vaxiom_persons: [person],
            },
          }) => setPerson(person)
        )
        .catch(() => notify(notifyError('Failed to person')))
    } else {
      setPerson(null)
    }
  }, [props.recipientId])

  return (
    <View
      {...props}
      recipientName={person && `${person.first_name} ${person.last_name}`}
    />
  )
}
